export default <X extends {}>(
  list: X[],
  startIndex: number,
  endIndex: number
): X[] => {
  const result = Array.from(list);

  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);

  return result;
};
